var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createStyles, makeStyles } from '@hawkins/styles';
export function toggleStyles(theme) {
    var _a, _b;
    var hawkins = theme.hawkins, hawkinsUtils = theme.hawkinsUtils, hawkinsVariables = theme.hawkinsVariables;
    var isDarkTheme = hawkins.theme === 'dark';
    var thumbDim = hawkinsVariables.sizingValues.size0 * 1.5;
    // Need to subtract 1px due to the transparent border we add to support Windows High Contrast Mode.
    var trackPadding = hawkinsVariables.spacingValues.space0 / 2 - 1;
    var trackWidth = hawkinsVariables.sizingValues.size3;
    return createStyles({
        '@media (prefers-reduced-motion: no-preference)': {
            track: { transition: '250ms' },
        },
        /** Class name of the focus ring anchor element. */
        focusRingAnchor: {
            bottom: 0,
            left: 0,
            position: 'absolute',
            right: 0,
            top: 0,
            zIndex: 0,
        },
        /** Class name of the native `input` element. */
        input: (_a = {
                cursor: 'pointer',
                height: '100%',
                margin: 0,
                opacity: 0,
                position: 'absolute',
                width: '100%',
                zIndex: 1
            },
            _a[hawkinsUtils.getFocusRingedElementSelector('&', ' ~ $focusRingAnchor')] = hawkinsUtils.getFocusRingedElementStyle({ position: 'absolute' }, __assign(__assign({}, hawkinsUtils.getFocusRingPosition(2)), { borderRadius: hawkinsVariables.borderRadiusValues.borderRadius0 * 3.5 })),
            _a['&:enabled'] = (_b = {},
                _b[hawkinsUtils.getHoveredElementSelector('&', ':checked + $track')] = {
                    backgroundColor: hawkins.interactive.backgroundColorHover,
                },
                _b[hawkinsUtils.getHoveredElementSelector('&', ':not(:checked) + $track')] = {
                    backgroundColor: hawkins.ui.backgroundColor4,
                },
                _b['&:checked + $track'] = {
                    backgroundColor: hawkins.interactive.backgroundColorRegular,
                    '& $toggleIcon': {
                        color: hawkins.persistent.iconFillWhiteRegular,
                    },
                },
                _b),
            _a['&:disabled'] = {
                cursor: 'not-allowed',
                '& + $track $thumb': {
                    backgroundColor: isDarkTheme
                        ? hawkins.persistent.backgroundColorWhiteXlight
                        : hawkins.persistent.backgroundColorWhiteRegular,
                },
                '&:checked + $track': {
                    backgroundColor: hawkins.interactive.backgroundColorDisabled,
                    '& $toggleIcon': { color: hawkins.icon.fillReverseLight },
                },
                '&:not(:checked) + $track': {
                    backgroundColor: hawkins.ui.backgroundColor3,
                    '& $toggleIcon': { color: hawkins.persistent.iconFillWhiteXlight },
                },
            },
            _a['&:checked + $track'] = {
                // Need to subtract an extra 2px due to the transparent borders we add to support Windows High Contrast Mode.
                '& $thumb': { transform: "translateX(".concat(trackWidth - trackPadding * 2 - thumbDim - 2, "px)") },
                '& $toggleIconOff': { visibility: 'hidden' },
            },
            _a['&:not(:checked) + $track $toggleIconOn'] = { visibility: 'hidden' },
            _a),
        /** Class name of the label. */
        label: {},
        /** Class name of the root element. */
        root: {
            alignItems: 'center',
            cursor: 'pointer',
            display: 'inline-flex',
            flexWrap: 'wrap',
            gap: hawkinsVariables.spacings.space1,
        },
        /** Class name of the root element when the component is disabled. */
        rootDisabled: {
            cursor: 'not-allowed',
        },
        /** Class name of the toggle handle. */
        thumb: {
            backgroundColor: hawkins.persistent.backgroundColorWhiteRegular,
            // Support Windows High Contrast Mode (see https://kittygiraudel.com/2021/04/05/an-accessible-toggle/).
            border: '1px solid transparent',
            borderRadius: '50%',
            boxShadow: hawkins.elevation.boxShadow1,
            height: thumbDim,
            left: trackPadding,
            position: 'absolute',
            transition: 'inherit',
            width: thumbDim,
        },
        /** Class name of the element containing the toggle and native `input`. */
        toggleContainer: {
            position: 'relative',
        },
        /** Class name of the toggle icons. */
        toggleIcon: {
            color: hawkins.persistent.iconFillWhiteLight,
        },
        /** Class name of the “Off” toggle icon. */
        toggleIconOff: {},
        /** Class name of the “On” toggle icon. */
        toggleIconOn: {},
        /** Class name of the toggle track. */
        track: {
            alignItems: 'center',
            backgroundColor: hawkins.ui.backgroundColor5,
            // Support Windows High Contrast Mode (see https://kittygiraudel.com/2021/04/05/an-accessible-toggle/).
            border: '1px solid transparent',
            borderRadius: hawkinsVariables.borderRadiusValues.borderRadius0 * 2.5,
            display: 'flex',
            height: hawkinsVariables.sizings.size1,
            position: 'relative',
            width: trackWidth,
        },
    });
}
export var useToggleStyles = makeStyles(toggleStyles, { name: 'Hawkins-Toggle' });
